import { lazy } from "react";

const ManageHoliday = lazy(() => import("./ManageHoliday"));
const ManageLeave = lazy(() => import("./ManageLeave"));

const hrcal = [
  {
    path: "/HRCal/Manage Holiday",
    element: <ManageHoliday />,
  },
  {
    path: "/HRCal/Manage Leave",
    element: <ManageLeave />,
  },
];

export default hrcal;
